
const digest = '4e1cffbc9d667cbcd4c3c4836c09641768a3aa389814f0eedfba271284d14219';
const classes = {"wrapper":"_wrapper_1ga4g_1","name":"_name_1ga4g_7","item":"_item_1ga4g_11"};
const css = `._wrapper_1ga4g_1 {
  font-family: Rubik, "sans-serif";
  display: flex;
  flex-direction: column;
  gap: 10px;
}
._wrapper_1ga4g_1 ._name_1ga4g_7 {
  font-size: 15px;
  font-weight: 600;
}
._wrapper_1ga4g_1 ._item_1ga4g_11 {
  font-size: 14px;
}
._wrapper_1ga4g_1 ._item_1ga4g_11 span {
  color: #9ea0a5;
  font-size: 12px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  